import React, { useState } from "react";
import { MapPin, Phone, Mail, Building2, Clock, Send } from "lucide-react";
import { company } from "../mock";
import { useToast } from "../hooks/use-toast";

const PageHeader = ({ title, subtitle }) => (
  <section className="bg-[#0B2545] text-white pt-16 pb-20 relative overflow-hidden">
    <div className="absolute inset-0 opacity-20">
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-[#00A859] rounded-full blur-3xl" />
    </div>
    <div className="max-w-[1400px] mx-auto px-6 relative">
      <span className="text-[#00A859] text-sm font-bold uppercase tracking-[3px] mb-3 block">Metal Solutions</span>
      <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight mb-3">{title}</h1>
      <p className="text-lg text-gray-300 max-w-2xl">{subtitle}</p>
    </div>
  </section>
);

const Contatti = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const submit = (e) => {
    e.preventDefault();
    toast({ title: "Messaggio inviato!", description: "Ti contatteremo a breve. Grazie." });
    setForm({ name: "", email: "", phone: "", subject: "", message: "" });
  };
  const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <>
      <PageHeader title="Contatti" subtitle="Siamo a disposizione per qualsiasi richiesta o preventivo. Contattaci attraverso il canale che preferisci." />
      <section className="py-20 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-6 grid lg:grid-cols-3 gap-8">
          <div className="space-y-5">
            {[
              { Icon: Building2, title: "Sede Legale", lines: [company.address, company.city, company.country] },
              { Icon: MapPin, title: company.warehouse.label, lines: [company.warehouse.address, company.warehouse.city] },
              { Icon: Phone, title: "Telefono", lines: [company.tel], href: `tel:${company.telRaw}` },
              { Icon: Mail, title: "Email PEC", lines: [company.email], href: `mailto:${company.email}` },
              { Icon: Clock, title: "Orari", lines: ["Lun - Ven: 8:00 - 12:30", "14:00 - 18:00"] },
            ].map((c) => (
              <div key={c.title} className="bg-white border border-gray-100 rounded-2xl p-6 hover:shadow-md hover:border-[#00A859] transition-all">
                <div className="flex gap-4">
                  <div className="w-11 h-11 rounded-xl bg-[#00A859]/10 flex items-center justify-center shrink-0">
                    <c.Icon className="w-5 h-5 text-[#00A859]" />
                  </div>
                  <div className="text-sm">
                    <div className="font-bold text-[#0B2545] mb-1 uppercase tracking-wide text-xs">{c.title}</div>
                    {c.lines.map((l, i) => (
                      c.href && i === 0 ? (
                        <a key={`${c.title}-${l}`} href={c.href} className="text-gray-700 hover:text-[#00A859] block">{l}</a>
                      ) : (
                        <div key={`${c.title}-${l}`} className="text-gray-700">{l}</div>
                      )
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-2 bg-white border border-gray-100 rounded-2xl p-8 md:p-10 shadow-sm">
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#0B2545] mb-2">Richiedi informazioni</h2>
            <p className="text-gray-600 mb-8 text-sm">Compila il modulo e ti risponderemo entro 24 ore lavorative.</p>
            <form onSubmit={submit} className="space-y-5">
              <div className="grid md:grid-cols-2 gap-5">
                <Field label="Nome e Cognome *" value={form.name} onChange={change("name")} required />
                <Field label="Email *" type="email" value={form.email} onChange={change("email")} required />
                <Field label="Telefono" value={form.phone} onChange={change("phone")} />
                <Field label="Oggetto *" value={form.subject} onChange={change("subject")} required />
              </div>
              <Field label="Messaggio *" textarea value={form.message} onChange={change("message")} required />
              <button type="submit" className="inline-flex items-center gap-2 bg-[#00A859] hover:bg-[#00874A] text-white font-bold px-7 py-3.5 rounded-full text-sm uppercase tracking-wide transition-colors">
                <Send className="w-4 h-4" /> Invia messaggio
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

const Field = ({ label, textarea, type = "text", value, onChange, required }) => (
  <label className="block">
    <span className="text-xs font-bold text-[#0B2545] uppercase tracking-wider mb-2 block">{label}</span>
    {textarea ? (
      <textarea
        value={value}
        onChange={onChange}
        required={required}
        rows={5}
        className="w-full px-4 py-3 border border-gray-200 rounded-xl outline-none focus:border-[#00A859] transition-colors text-sm"
      />
    ) : (
      <input
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        className="w-full px-4 py-3 border border-gray-200 rounded-xl outline-none focus:border-[#00A859] transition-colors text-sm"
      />
    )}
  </label>
);

export default Contatti;
export { PageHeader };
